import React from "react";
import { useParams } from "react-router-dom";
import { useGetManufacturerByIdQuery } from "../../redux/api/manufacturersApi";

const ManufacturerDetailsPage = () => {
  const { id } = useParams();
  const { data: manufacturer, isLoading, error } = useGetManufacturerByIdQuery(id);

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error: {error?.data?.message || error?.error || 'Failed to load manufacturer'}</div>;
  if (!manufacturer) return <div>Manufacturer not found</div>;

  return (
    <div>
      <h1 className="mb-4">Manufacturer Details</h1>

      {/* Manufacturer Metadata */}
      <div className="card mb-4">
        <div className="card-header">Manufacturer Information</div>
        <div className="card-body">
          <p>
            <strong>ID:</strong> {manufacturer.manufacturer_id || manufacturer.id}
          </p>
          <p>
            <strong>Name:</strong> {manufacturer.name}
          </p>
          <p>
            <strong>Contact Person:</strong> {manufacturer.contact_person || manufacturer.contact}
          </p>
          <p>
            <strong>Email:</strong> {manufacturer.contact_email || manufacturer.email}
          </p>
          <p>
            <strong>Phone:</strong> {manufacturer.contact_phone || manufacturer.phone}
          </p>
          <p>
            <strong>Address:</strong> {manufacturer.address}
          </p>
        </div>
      </div>

      {/* Manufacturer Products */}
      <div className="card">
        <div className="card-header">Products</div>
        <div className="card-body">
          {manufacturer.products && manufacturer.products.length > 0 ? (
            <table className="table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Product Name</th>
                  <th>Category</th>
                </tr>
              </thead>
              <tbody>
                {manufacturer.products.map((product, index) => (
                  <tr key={product.id || product.product_id}>
                    <td>{index + 1}</td>
                    <td>{product.name}</td>
                    <td>{product.category}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p className="text-muted">No products associated with this manufacturer.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ManufacturerDetailsPage;
